import React from 'react'
import Accordions from "../../../components/Accordions";

const Sem6Civil1 = () =>{
  const data = [
    {
      subjectName: "2023 Batch",
      units: [ ],
      links: [
        {
          url: "https://www.sonatech.ac.in/academics/syllabus/B.E-B.Tech/2023-Batch/Civil-1%20to%206%20Sem-Curriculum%20&%20Syllabus%20with%20Honours%201.pdf",
          title: "Syllabus",
        },
      ],
    },
    {
      subjectName: "2024 Batch",
      units: [],
      links: [
        {
          url: "",
          title: "Syllabus",
        },
      ],
    },
            {
      subjectName: "2025 Batch",
      units: [ ],
      links: [
        {
          url: "",
          title: "Syllabus",
        },
      ],
    },
    ];
  return (
    <div className="min-h-screen pt-12 m-auto w-[90%]">
      <h1 className="text-xl font-semibold flex justify-center">CIVIL Sem - 6</h1>
      <Accordions data={data} />
    </div>
  );
};

export default Sem6Civil1